import React, { Component } from 'react';
import { Modal, Button} from 'react-bootstrap';

export default class NoRecord extends Component {  
    handleCallBack = () =>{
      this.props.onCallBack()
    }

    render(){
      return(
      <Modal show={true}
      onHide={this.props.closeModal}
      dialogClassName="modal-120w"
      size='md'
      aria-labelledby="contained-modal-title-vcenter"
      centered>     
      <Modal.Body>
        Are you sure, No Recording is Available?
      </Modal.Body>
      <Modal.Footer>
      <Button onClick={this.handleCallBack}> OK </Button> &nbsp;
      <Button onClick={this.props.closeRecord}> Cancel </Button>
      </Modal.Footer>
      </Modal>
      )
    }
    
 
}

  